import React, { useState, useEffect } from "react";
import { Checkbox } from "antd";
import DebounceInput from "../commonComponents/DebounceInput";

const ColumnVisibilityPanel = ({
  columns = [],
  visibleColumns = [],
  onColumnVisibilityChange,
  defaultVisibleColumns = [],
  // When true, the panel renders no search box of its own and filters by
  // `externalSearch` instead — used when a parent (e.g. the grouped media
  // drawer) owns a single search that spans multiple sections.
  hideSearch = false,
  externalSearch = "",
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [selectedColumns, setSelectedColumns] = useState(visibleColumns);

  useEffect(() => {
    setSelectedColumns(visibleColumns);
  }, [visibleColumns]);

  const handleSearch = value => {
    setSearchValue(value);
  };

  const handleColumnCheck = (columnKey, checked) => {
    const newSelectedColumns = checked
      ? [...selectedColumns, columnKey]
      : selectedColumns.filter(key => key !== columnKey);

    setSelectedColumns(newSelectedColumns);

    if (onColumnVisibilityChange) {
      onColumnVisibilityChange(newSelectedColumns);
    }
  };

  const activeSearch = hideSearch ? externalSearch : searchValue;
  const filteredColumns = columns.filter(column =>
    column.title?.toLowerCase().includes(activeSearch.toLowerCase())
  );

  return (
    <div className="column-visibility-panel">
      {!hideSearch && (
        <DebounceInput
          allowClear
          className="w-full mb-4"
          placeholder="Search columns"
          value={searchValue}
          onChange={handleSearch}
        />
      )}

      <div className="column-checkboxes">
        {filteredColumns.map(column => (
          <div key={column.key || column.dataIndex} className="mb-2">
            <Checkbox
              checked={selectedColumns.includes(column.key || column.dataIndex)}
              onChange={e => handleColumnCheck(column.key || column.dataIndex, e.target.checked)}
            >
              {column.title}
            </Checkbox>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ColumnVisibilityPanel;
